import Vue from 'vue'
import Router from 'vue-router'
import vue_app from '@/main'
import fillInfo from '@/pages/fillInfo'
import index from '@/pages/index'
import payConfirm from '@/pages/payConfirm'
import getCardSuccess from '@/pages/getCardSuccess'
import payResult from '@/pages/payResult'
import inputIccid from '@/pages/inputIccid'
import pkgList from '@/pages/pkgList'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/fillInfo',
      name: 'fillInfo',
      component: fillInfo,
      meta: {
      	title_zh: '填写信息',
      	title_hk: '填寫信息',
      },
    },
    {
    	path: '/',
    	name: 'index',
    	component: index,
    	meta: {
      	title_zh: '中国电信CTExcel|香港免费体验卡',
      	title_hk: '中國電信CTExcel|香港免費體驗卡',
      },
    },
    {
    	path: '/payConfirm',
    	name: 'payConfirm',
    	component: payConfirm,
    	meta: {
      	title_zh: '支付确认页面',
      	title_hk: '支付確認頁面',
      },
    },
    {
    	path: '/getCardSuccess',
    	name: 'getCardSuccess',
    	component: getCardSuccess,
    	meta: {
      	title_zh: '领卡成功页面',
      	title_hk: '領卡成功頁面',
      },
    },
    {
    	path: '/payResult',
    	name: 'payResult',
    	component: payResult,
    	meta: {
      	title_zh: '支付结果页面',
      	title_hk: '支付結果頁面',
      },
    },
    {
    	path: '/inputIccid',
    	name: 'inputIccid',
    	component: inputIccid,
    	meta: {
      	title_zh: '输入ICCID',
      	title_hk: '輸入ICCID',
      },
		},
		{
    	path: '/pkgList',
    	name: 'pkgList',
    	component: pkgList,
    	meta: {
      	title_zh: '套餐列表',
      	title_hk: '套餐列表',
      },
    },
  ],
  scrollBehavior (to, from, savedPosition) {
  	if(to.hash){
	  	return {
	      selector: to.hash
	    }
  	}else{
    	return { x: 0, y: 0 }
  	}
	}
})

router.beforeEach((to, from, next) => {
	setTimeout(function(){//因为js获取vue对象需要异步
		//监视语言变化 及时修改title
		vue_app.$watch('$i18n.locale',function(newVal, oldVal){
			if(vue_app.$i18n.locale == 'zh'){
				/* 路由发生变化修改页面title */
				document.title = to.meta.title_zh;
			}else{
				document.title = to.meta.title_hk;
			}
		})
		if(vue_app.$i18n.locale == 'zh'){
			document.title = to.meta.title_zh;
		}else{
			document.title = to.meta.title_hk;
		}
		next();
	},10)
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js